import { Injectable } from '@angular/core';
import { LoadingComponent } from '../components/loading/loading.component';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  private loadingModal!: HTMLIonModalElement;

  constructor(
    private toastController: ToastController,
    private translate: TranslocoService,
    private modalController: ModalController,
  ) {}

  async showToast(
    i18nKey: string,
    color: 'success' | 'danger' | 'warning' | 'primary' | 'secondary' | 'tertiary' = 'success',
    duration = 2000,
    params?: Record<string, unknown>,
  ) {
    const toast = await this.toastController.create({
      message: this.translate.translate(i18nKey, params),
      color,
      duration,
      position: 'top',
      icon: color === 'danger' ? 'alert-circle' : 'checkmark',
      swipeGesture: 'vertical',
    });
    toast.present();
  }

  async showLoading() {
    this.loadingModal = await this.modalController.create({
      component: LoadingComponent,
      cssClass: 'loading-modal',
      animated: false,
      showBackdrop: true,
      backdropDismiss: true,
    });
    await this.loadingModal.present();
  }

  async hideLoading() {
    await this.loadingModal.dismiss();
  }
}
